module.exports = __webpack_public_path__ + "assets/img/swisse.f2049064.png";